import { flexPrefixCls } from "@/base/components/flex/Flex.component";
import { THEME_PREFIX } from "@/base/constant";
import {
  genComponentStyleHook,
  type FullToken,
  type GenerateStyle,
} from "antd/es/theme/internal";

const genStyle: GenerateStyle<FullToken<"Flex">> = () => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${flexPrefixCls}`]: {},
  },
});

export const useFlexStyle = genComponentStyleHook(["Flex", "cso"], (token) => {
  return [genStyle(token)];
});
